import { Row } from 'react-table';
('app/assets/icons/my-fleet-icon.svg');


import styles from './PortsPage.module.scss';

import { Port } from 'ais-facade-api/api';
import { PortActionCell } from 'app/components/PortActionCell';
import { CountryFlag } from 'CountryFlag/CountryFlag';

import { Link } from 'react-router-dom';
import { Icon } from '../../components';
import { PortCatalogData } from 'ais-facade-api/api';
import { glToStringHDMS } from 'app/helpers';
import { useAppSelector } from 'app/store/store';
import { useMemo } from 'react';
import clsx from 'clsx';

export const columns = [
  {
    Header: 'Name',
    accessor: 'cityName',
    Cell: ({ row: { original: port } }: { row: Row<Port> }) =>
      typeof port.cityName === 'string' ? (
        typeof port.key === 'string' ? (
          <Link to={`/ports/${port.key}`} className={styles.link}>
            {port.cityName}
          </Link>
        ) : (
          <> {port.cityName}</>
        )
      ) : (
        <>&mdash;</>
      ),
    canSort: true,
    sortBy: 'CITY_NAME',
  },
  {
    Header: 'UN/LOCODE',
    accessor: 'locode',
    Cell: ({ row: { original: port } }: { row: Row<Port> }) => (
      <>{typeof port.locode === 'string' || typeof port.un === 'string' ? `${port.un} ${port.locode}` : <>&mdash;</>}</>
    ),
    canSort: true,
    sortBy: 'UN_LOCODE',
  },
  {
    Header: 'Country',
    accessor: 'country',
    Cell: ({ row: { original: port } }: { row: Row<Port> }) => (
      <>
        {port.countryCode && <CountryFlag countryCode={port.countryCode.toLowerCase()} />}
        {typeof port.countryCode === 'string' || typeof port.meta?.countryName === 'string' ? (
          `${port.meta?.countryName} (${port.countryCode})`
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
    sortBy: 'COUNTRY_CODE',
  },
  {
    Header: 'HarborType',
    accessor: 'harborType',
    Cell: ({ row: { original: port } }: { row: Row<PortCatalogData> }) => (
      <>{port?.characteristics?.harborType ? port.characteristics.harborType : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'HarborUse',
    accessor: 'harborUse',
    Cell: ({ row: { original: port } }: { row: Row<PortCatalogData> }) => (
      <>{port?.characteristics?.harborUse ? port.characteristics.harborUse : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'Coordinates',
    accessor: 'lat',
    Cell: ({ row: { original: port } }: { row: Row<Port> }) => {
      const profile = useAppSelector((state) => state.userSlice.profile);
      const coordinatesFormat = useMemo(() => profile?.ui?.['coordinatesFormat'] ?? 'DMS', [profile]);

      return (
        <>
          {typeof port.lat === 'number' && typeof port.lon === 'number' ? (
            glToStringHDMS([port.lon, port.lat], coordinatesFormat)
          ) : (
            <>&mdash;</>
          )}
        </>
      );
    },
  },
  {
    Header: <Icon name="more-icon" width="13px" height="3px" />,
    accessor: 'actionCell',
    width: 34,
    minWidth: 34,
    maxWidth: 34,
    disableSortBy: true,
    Cell: ({ row: { original: port } }: { row: Row<Port> }) => (
      <div className={clsx(styles.center_icon_cell, styles.action_cell)}>
        <PortActionCell port={port} />
      </div>
    ),
  },
];
